var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock15X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6F087961-2948-4784-A818-DD499A535C6D@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C9.98528137,0 12,2.01471863 12,4.5 L12,6.75 L12.75,6.75 C13.9926407,6.75 15,7.75735931 15,9 L15,14.25 C15,15.4926407 13.9926407,16.5 12.75,16.5 L2.25,16.5 C1.00735931,16.5 0,15.4926407 0,14.25 L0,9 C0,7.75735931 1.00735931,6.75 2.25,6.75 L3,6.75 L3,4.5 C3,2.08572667 4.90123652,0.115510911 7.2881643,0.0048979895 Z M12.75,8.25 L2.25,8.25 C1.83578644,8.25 1.5,8.58578644 1.5,9 L1.5,14.25 C1.5,14.6642136 1.83578644,15 2.25,15 L12.75,15 C13.1642136,15 13.5,14.6642136 13.5,14.25 L13.5,9 C13.5,8.58578644 13.1642136,8.25 12.75,8.25 Z M7.5,1.5 C5.84314575,1.5 4.5,2.84314575 4.5,4.5 L4.5,6.75 L10.5,6.75 L10.5,4.5 C10.5,2.90231912 9.25108004,1.59633912 7.67627279,1.50509269 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05_01_Abonnement",
    transform: "translate(-201.000000, -425.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(170.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/lock",
    transform: "translate(1.500000, 46.750000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#182B43",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock15X);
export default __webpack_public_path__ + "static/media/lock@1,5x.122d2e43ddc54ef005bb16ffd3c02684.svg";
export { ForwardRef as ReactComponent };